import React from 'react'
import EducationCardBody from './EducationCardBody';

export const Educations = () => {
  return (
    <>
      <div className="project-section container-fluid">
        <h1 className="section-heading">#Educations</h1>
        <div className="projectCards">
          <EducationCardBody></EducationCardBody>
        </div>
      </div>
    </>
  )
}

export default Educations;
